import $ from 'jquery';
import Lockr from 'lockr';

import FullPage from './FullPage';

const $window = $(window);
const $page = $('.js-preloader-page');
const equalizerWidth = 1920;

export default class Preloader {
  constructor($c) {
    window.__kriosPreloaderOwned = true;
    this.$c = $c;
    this.$percentage = $c.find('.js-preloader-percentage');
    this.$equalizer = $c.find('.js-preloader-equalizer');

    const hidePreloader = Lockr.get('hidePreloader');

    if (hidePreloader) {
      Preloader.hide(true);
    } else {
      this.initPreloader();
    }
  }
  initPreloader() {
    let isLoaded = false;

    FullPage.lock(true);
    $window.on('load', () => {
      isLoaded = true;
    });

    const interval = setInterval(() => {
      const progress = this.getProgress();

      if (progress >= 100) {
        clearInterval(interval);
        Preloader.hide();
        return;
      }

      if (progress < 50 || isLoaded) {
        this.updateProgress(progress + 1);
      }
    }, 25);
  }
  updateProgress(value) {
    const width = (equalizerWidth / 100) * value;

    this.$equalizer.width(width);
    this.$percentage.text(value);
  }
  getProgress() {
    return +this.$percentage.text();
  }
  static hide(fast = false) {
    Lockr.set('hidePreloader', true);
    FullPage.lock(false);

    if (fast) {
      $page.addClass('_loaded-before');
    } else {
      $page.addClass('_loaded');
    }
  }
}
